import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import Form from 'components/react-validation/components/form';
import Input from 'components/react-validation/components/input';
import Submit from 'components/react-validation/components/submit';
import * as Vali from 'helper/validator-helper';

export class ChangePasswordModal extends Component {

  static propTypes = {
    isOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    onChangePassword: PropTypes.func,
    modalName: PropTypes.string,
    errorMsg: PropTypes.array,
    item: PropTypes.object
  }

  constructor(props) {
    super(props);
  }

  onSubmit = (e) => {
    e.preventDefault();
    const valueForm = this.formChangePassword.getValues();
    if (!valueForm['newPassword']) {
      this.formChangePassword.resetField(this.refs, 'newPassword');
      this.formChangePassword.showError(this.refs['newPassword'], 'This field is required');
      this.formChangePassword.resetField(this.refs, 'confirmNewPassword');
      this.formChangePassword.showError(this.refs['confirmNewPassword'], 'This field is required');
    } else {
      this.props.onChangePassword(e, valueForm, this.onChangePasswordCallback);
    }
  }

  onChangePasswordCallback = (status, data) => {
    this.formChangePassword.showError(this.refs['currentPassword'], data[0]);
  }

  render() {
    return (
      <Modal
        show={this.props.isOpen}
        dialogClassName='custom-modal'
        backdrop='static'
        container={this}
        id='rename-modal'
      >
        <Form ref={ref => { this.formChangePassword = ref; }} onSubmit={() => {return false;}}>
          <Modal.Header>
            <Modal.Title id='contained-modal-title-lg'>Change my password</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='form-group'>
              <label>Current password <span className='text-danger'>*</span></label>
              <Input type='password'
                ref='currentPassword'
                name='currentPassword'
                placeholder='Current password'
                className='form-control'
                errorMsg='Password length is between 4-40'
                maxLength='40'
                max='40'
                min='4'
                validations={[Vali.required, Vali.maxlength, Vali.minlength]} />

            </div>
            <div className='form-group'>
              <label>New password <span className='text-danger'>*</span></label>
              <Input type='password'
                ref='newPassword'
                name='newPassword'
                placeholder='New password'
                className='form-control'
                errorMsg='Password length is between 4-40'
                maxLength='40'
                max='40'
                min='4'
                validations={[Vali.required, Vali.maxlength, Vali.minlength]} />
            </div>
            <div className='form-group'>
              <label>Confirm new password <span className='text-danger'>*</span></label>
              <Input type='password'
                ref='confirmNewPassword'
                name='confirmNewPassword'
                placeholder='Confirm new password'
                className='form-control'
                maxLength='40'
                max='40'
                min='4'
                compare='newPassword'
                errorMsg='Confirmed password does not match the password above'
                validations={[Vali.required, Vali.maxlength, Vali.compare]} />
            </div>
          </Modal.Body>

          <Modal.Footer>
            <a className='btn btn-primary margin-right-5 btn-siteone-default' onClick={this.props.closeModal}>Cancel</a>
            <Submit className='btn btn-primary btn-siteone margin-left-10' onClick={this.onSubmit}>Save</Submit>
          </Modal.Footer>

        </Form>

      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/User/Components/change-password-modal.js